import { type LinkHTMLAttributes, forwardRef } from "react"

import { type VariantProps, cva } from "class-variance-authority"

import { cn } from "@/lib/shadcn-utils"

const linkVariants = cva("tw-text-sm tw-normal-case", {
  variants: {
    variant: {
      default: "tw-text-primary",
      ghost: "tw-text-subtle",
    },
  },
  defaultVariants: {
    variant: "default",
  },
})

interface LinkProps
  extends LinkHTMLAttributes<HTMLAnchorElement>,
    VariantProps<typeof linkVariants> {
  external?: boolean
}

const Link = forwardRef<HTMLAnchorElement, LinkProps>(
  ({ children, className, variant, external = false, ...props }, ref) => {
    return (
      <a
        className={cn(linkVariants({ variant, className }))}
        onClick={(e) => e.stopPropagation()}
        target={external ? "_blank" : undefined}
        rel={external ? "noopener noreferrer" : undefined}
        ref={ref}
        {...props}
      >
        {children}
      </a>
    )
  },
)
Link.displayName = "Link"

export { Link, linkVariants }
